module.exports = __webpack_public_path__ + "static/media/technology.e1916f9b.jpg";